import i18n from '@/i18n';
import { MINUTES_IN_HOUR } from '@/lib/date-time/constants';

export const presentMinutes = (
  minutes: number,
  shortFormat = true,
  highPrecision: boolean = false,
): string => {
  const isNegative = minutes < 0;
  minutes = Math.abs(minutes);
  const hours = Math.floor(minutes / 60);
  let hoursString = '';

  if (shortFormat && hours) {
    hoursString = `${hours}h`;
  } else if (hours) {
    hoursString = i18n.tc('unitWithAmount.hour', hours).toString();
  }

  // High precision is used for timesheets with hours as 4 decimal places
  const mins = highPrecision
    ? Math.round(minutes % 60)
    : Math.floor(minutes % 60);
  let minsString = '';

  if (shortFormat && mins) {
    minsString = `${mins}m`;
  } else if (mins) {
    minsString = i18n.tc('unitWithAmount.minute', mins).toString();
  }

  let str;

  if (!hours && !mins) {
    str = '-';
  } else {
    str = `${hoursString} ${minsString}`.trim();
  }

  return isNegative ? `-${str}` : str;
};

/**
 * Returns a string with padded hours and minutes to 2 figures
 * e.g. 05h 08m
 * */
export const presentHoursAndMinutes = (mins: number): string => {
  const hours = Math.floor(mins / 60);
  const minutes = Math.floor(mins % 60);

  return `
  ${String(hours).padStart(2, '0')}h
  ${String(minutes).padStart(2, '0')}m`;
};

/**
 * Presents a number of hours as padded hours and minutes, settled on the nearest
 * minute first: decimal hours added together can fall a hair short of a whole minute
 * (5.8 + 10 x 11.6 comes to 121.79999999999998) and would otherwise show a minute less.
 */
export const presentHoursToNearestMinute = (hours: number): string =>
  presentHoursAndMinutes(Math.round(hours * MINUTES_IN_HOUR));

export const limitStat = (stat: number, limit: number) =>
  stat <= limit ? stat : `${limit}+`;

export const presentTimezoneOffset = (offset: number): string =>
  `GMT${offset >= 0 ? '+' : ''}${offset}`;
